import { fetchWrapper } from '~/utils/fetchWrapper'
import type { RepositoryBranch } from '~/types/Conversations'

export type MonitoringProvider = 'splunk'

export interface MonitoringAlert {
  id: number
  provider: MonitoringProvider
  provider_event_id: string | null
  summary: string | null
  payload: Record<string, unknown>
  created_time: string
}

export interface MonitoringInvestigateResponse {
  conversation_uuid: string
  initial_message: string
}

export interface MonitoringInvestigateRequest {
  repository_branches?: RepositoryBranch[]
  s3_upload_paths?: string[]
}

export interface MonitoringAlertsQuery {
  provider?: MonitoringProvider
  startTime?: string
  endTime?: string
  limit?: number
  offset?: number
}

const DEFAULT_LIMIT = 100
const DEFAULT_OFFSET = 0

export async function getMonitoringAlerts(
  workspaceUuid: string,
  query: MonitoringAlertsQuery = {}
): Promise<MonitoringAlert[]> {
  const params = new URLSearchParams()
  params.set('limit', String(query.limit ?? DEFAULT_LIMIT))
  params.set('offset', String(query.offset ?? DEFAULT_OFFSET))

  if (query.provider) {
    params.set('provider', query.provider)
  }
  if (query.startTime) {
    params.set('start_time', query.startTime)
  }
  if (query.endTime) {
    params.set('end_time', query.endTime)
  }

  return fetchWrapper.get<MonitoringAlert[]>(
    `/api/workspace/${workspaceUuid}/monitoring/alerts?${params.toString()}`,
    { credentials: 'include' }
  )
}

export async function investigateMonitoringAlert(
  workspaceUuid: string,
  alertId: number,
  request?: MonitoringInvestigateRequest
): Promise<MonitoringInvestigateResponse> {
  return fetchWrapper.post<MonitoringInvestigateResponse>(
    `/api/workspace/${workspaceUuid}/monitoring/alerts/${alertId}/investigate`,
    request,
    { credentials: 'include' }
  )
}
